import { SurfCloudAPI } from "../graphql/surfApi.js";
import { encodeSurfTargetParams } from "./surfJobTarget.js";
const TERMINAL = new Set(["COMPLETED", "FAILED", "CANCELLED", "TIMED_OUT"]);
export async function pollSurfImageJob(cfg, jobId, timeoutMs = 180_000) {
    const deadline = Date.now() + timeoutMs;
    while (Date.now() < deadline) {
        const job = await SurfCloudAPI.getAIJob(cfg, jobId);
        if (TERMINAL.has(job.status)) {
            if (job.status !== "COMPLETED") {
                throw new Error(job.errorMessage ?? `Job immagine ${job.status}`);
            }
            const key = job.outputAssetKey?.trim();
            if (!key)
                throw new Error("Job immagine senza outputAssetKey.");
            return key;
        }
        await new Promise((r) => setTimeout(r, 1500));
    }
    throw new Error("Timeout job immagine.");
}
export async function submitSurfImageJob(cfg, feature, prompt, options) {
    const params = {
        size: options?.size ?? "1536x1024",
        quality: "medium",
    };
    if (options?.background)
        params.background = options.background;
    if (options?.output_format)
        params.output_format = options.output_format;
    const paramsJson = options?.surfTarget
        ? encodeSurfTargetParams(params, options.surfTarget)
        : JSON.stringify(params);
    const job = await SurfCloudAPI.submitAIJob(cfg, {
        kind: "IMAGE_GENERATE",
        provider: "OPENAI",
        feature,
        prompt,
        paramsJson,
    });
    return job.jobId;
}
export async function submitSurfImageEditJob(cfg, feature, prompt, inputAssetKeys, options) {
    const keys = inputAssetKeys.map((k) => k.trim()).filter(Boolean);
    if (keys.length < 1 || keys.length > 4) {
        throw new Error("IMAGE_EDIT richiede da 1 a 4 immagini di input.");
    }
    const params = { size: "1536x1024", quality: "medium" };
    if (options?.background)
        params.background = options.background;
    if (options?.output_format)
        params.output_format = options.output_format;
    const paramsJson = options?.surfTarget
        ? encodeSurfTargetParams(params, options.surfTarget)
        : JSON.stringify(params);
    const job = await SurfCloudAPI.submitAIJob(cfg, {
        kind: "IMAGE_EDIT",
        provider: "OPENAI",
        feature,
        prompt,
        inputAssetKeys: keys,
        paramsJson,
    });
    return job.jobId;
}
